import request from '@/utils/request';

export default {
    // 添加企业信息
    async getSubItemStatistics (params) {
        const res = await request.get('/statistic/getSubItemStatistic', { params })
        return res.data
    },
    async getSubItemTypeStatistics (params) {
        const res = await request.get('/statistic/getSubItemTypeStatistic', { params })
        return res.data
    },
    async getItemStatisticsByYear (params) {
        const res = await request.get('/statistic/getSubItemRecordStatistic', { params })
        return res.data
    },
    async getSubWordStatistic (params) {
        const res = await request.get('/statistic/getSubWordStatistic', { params })
        return res.data
    },
    async getKnowledgeMap (params) {
        const res = await request.get('/statistic/getKnowledgeMap', { params })
        return res.data
    }
};
